// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"103":"e510d178","292":"4f622c05","406":"5c8642a8","696":"01a538b7","828":"e98d183e"}[chunkId] + ".chunk.js";
};